<script setup lang="ts">
import Headline from "../components/Headline.vue";
import Section from "../components/Section.vue";
import { List, ListItem } from "../components/List";
import type { Standard } from "../../types";

defineProps<{
  onPrintPerfectClick: () => void;
  artwork: Standard.Artwork;
}>();
</script>

<template>
  <Headline>
    <template #title>For Pros who know.</template>
    <template #subtitle>
      You don't need our help. We print exactly as you send it, without any cutting edge,
      industry-leading print enhancements.
    </template>
  </Headline>

  <Section class="print-as-is__section">
    <List>
      <ListItem kind="warning">
        No
        <a href="/jiffy-transfers-FAQs#transfer-quality-guarantee" target="_blank">
          PrintPerfect Guarantee
        </a>
      </ListItem>
      <ListItem kind="warning">No safety net</ListItem>
      <ListItem kind="warning">Quality depends on uploaded design</ListItem>
    </List>
  </Section>
</template>

<style scoped lang="scss">
.print-as-is {
  &__section {
    gap: 20px;
  }
}
</style>
